import React from 'react';
import { ChildSelector } from '@/components/account/ChildSelector';
import { TypeChildRecord } from '@/lib/api/accountManager/types';
import { TypePlayKitPageTranslations } from '@/utils/translations/types/TypePlayKitPageTranslations';
import type { Entry } from 'contentful';
import type { TypeImageFields } from '@/core/generated-types';
import { SubscriptionPageHeading } from '@/components/account/PlayKitSchedule/components';
import { Divider } from '@/components/account/PlayKitSchedule/components/Divider';

type SharedLayoutProps = {
  children: React.ReactNode;
  setSelectedChild: (childUuid: string) => void;
  selectedChild: TypeChildRecord | undefined;
  visibleChildren: TypeChildRecord[];
  t: TypePlayKitPageTranslations;
  icons: Entry<TypeImageFields>[];
};

const SharedLayout = ({
  children,
  setSelectedChild,
  selectedChild,
  visibleChildren,
  t,
  icons,
}: SharedLayoutProps) => {
  return (
    <div data-testid="playKitSchedule" className="mb-20">
      <ChildSelector
        setSelectedChild={setSelectedChild}
        selectedChild={selectedChild}
        visibleChildren={visibleChildren}
        t={t}
        icons={icons}
      />
      <SubscriptionPageHeading t={t} selectedChild={selectedChild} />
      <Divider />
      {children}
    </div>
  );
};

export default React.memo(SharedLayout);
